"use client";

import { useEffect, useRef } from "react";

export default function Reloader() {
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const reloadTimeRef = useRef<number | null>(null);
    const hasInteractedRef = useRef<boolean>(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const reloadParam = urlParams.get("reload");

        if (!reloadParam) {
            return;
        }

        const reloadSeconds = Number.parseInt(reloadParam, 10);
        if (Number.isNaN(reloadSeconds) || reloadSeconds <= 0) {
            return;
        }

        reloadTimeRef.current = reloadSeconds * 1000;

        const resetTimer = () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            timerRef.current = setTimeout(() => {
                window.location.reload();
                window.scrollTo(0, 0);
                hasInteractedRef.current = false;
            }, reloadTimeRef.current!);
        };

        const handleUserActivity = () => {
            hasInteractedRef.current = true;
            resetTimer();
        };

        const activityEvents = ["mousedown", "mousemove", "keypress", "scroll", "touchstart", "click"];

        for (const event of activityEvents) {
            document.addEventListener(event, handleUserActivity, true);
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            for (const event of activityEvents) {
                document.removeEventListener(event, handleUserActivity, true);
            }
        };
    }, []);

    return <></>;
}
